import { useEffect, useRef } from 'react';
import { WelcomeBtn, WelcomeContain, WelcomeDescription, WelcomeTitle } from './Welcome.styles';
import { useNavigate } from 'react-router-dom';
import Images from 'src/App/Images';
import { useAppSelector } from 'src/App/redux/hooks';
import { RootState } from 'src/App/redux/store';
import { toast } from 'react-toastify';

export function Welcome() {
	const navigate = useNavigate();
	const nextTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

	const platform = useAppSelector((state: RootState) => state.app.platform);
	const status = useAppSelector((state: RootState) => state.app.status);
	const isDebug = useAppSelector((state: RootState) => state.app.isDebug);

	// Will wait a few seconds to boot things up if the user doesn't press next
	useEffect(() => {
		if (status === 'ready') {
			nextTimeoutRef.current = setTimeout(next, 3000);

			const queryParams = globalThis?.location?.search;
			const type = queryParams?.match(/type=(\w+)/)?.[1];
			if (type === 'config') {
				toast.success('Configuration is complete, you may close this window and use the extension on your channel now');
			}
		}
		return () => {
			clearTimeout(nextTimeoutRef.current!);
		};
	}, [status]);

	function next() {
		if (status === 'ready' || isDebug) {
			clearTimeout(nextTimeoutRef.current!);
			navigate('/home');
		}
	}

	return (
		<WelcomeContain platform={platform}>
			<Images.GrayLogo />
			<Images.GrayLogo />
			<Images.GrayLogo />
			<Images.GrayLogo />

			<WelcomeTitle>
				Lumia Stream
				<br />
				Extension
			</WelcomeTitle>
			<WelcomeDescription>Interact with your favorite streamer directly</WelcomeDescription>
			<WelcomeBtn disabled={status !== 'ready'} onClick={next}>
				Next
			</WelcomeBtn>
		</WelcomeContain>
	);
}
